import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { DashboardPage } from 'foundations-components/transitional/components/DashboardPage';
import { Header } from 'foundations-components/transitional/components/Header';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import { SEARCH_BAR_INLINE_SIZE } from '../constants/searchBar';
import { StorefrontTabNav } from '../navigation/components/StorefrontTabNav';
import { SearchBar } from '../search-bar/components/SearchBar';
import { ManageBuildDropdowns } from './headers/ManageBuildDropdowns';
import { PageCallouts } from '../hero/components/PageCallouts';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function StorefrontDashboardWithTabs({
  children,
  interleaveBanners = false
}) {
  const {
    searchBarInlineSize,
    isCompactHeader
  } = useResponsiveProps({
    searchBarInlineSize: {
      xs: '100%',
      md: SEARCH_BAR_INLINE_SIZE
    },
    isCompactHeader: {
      xs: true,
      md: false
    }
  });
  return /*#__PURE__*/_jsxs(DashboardPage, {
    headerComponent: /*#__PURE__*/_jsx(Header, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.headers.title"
      }),
      tabs: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        justifyContent: "space-between",
        gap: "500",
        minInlineSize: "0",
        children: [/*#__PURE__*/_jsx(View, {
          flex: "1",
          minInlineSize: "0",
          children: /*#__PURE__*/_jsx(StorefrontTabNav, {})
        }), /*#__PURE__*/_jsx(View, {
          flexShrink: 0,
          children: /*#__PURE__*/_jsx(ManageBuildDropdowns, {})
        })]
      }),
      children: /*#__PURE__*/_jsx(Flex, {
        alignItems: isCompactHeader ? 'stretch' : 'center',
        flexDirection: isCompactHeader ? 'column' : 'row',
        gap: "500",
        minInlineSize: "0",
        inlineSize: isCompactHeader ? '100%' : undefined,
        children: /*#__PURE__*/_jsx(View, {
          inlineSize: searchBarInlineSize !== null && searchBarInlineSize !== void 0 ? searchBarInlineSize : SEARCH_BAR_INLINE_SIZE,
          maxInlineSize: "100%",
          minInlineSize: "0",
          marginBlockStart: isCompactHeader ? '500' : undefined,
          children: /*#__PURE__*/_jsx(SearchBar, {})
        })
      })
    }),
    children: [/*#__PURE__*/_jsx(PageCallouts, {
      showBanners: !interleaveBanners
    }), children]
  });
}